module.exports = {
      id: "ic-linedot-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-linedot-normal-usage",
      toString: function () {
        return this.url;
      }
    }